import * as faq from './faq.service';

export const Faq = {
  ...faq,
};
